var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.block.component,_vm._b({directives:[{name:"editable",rawName:"v-editable",value:(_vm.block),expression:"block"}],key:_vm.block._uid,tag:"component",attrs:{"story-fields":_vm.storyFields}},'component',_vm.mappedBlock,false))}
var staticRenderFns = []

export { render, staticRenderFns }